import api from './api'

/**
 * Acesso temporário `automais-temp` (8h) para entrar no device por fora da plataforma
 * (SSH root no Linux, Winbox no MikroTik) sem repassar senha. A nuvem revoga no vencimento;
 * se não conseguir, a concessão fica `vulnerable` e a linha do device fica vermelha.
 */
export const tempAccessApi = {
  /** Concessão ativa (com senha) ou cria uma nova no device. Pode pedir MFA (interceptor do api). */
  grant: async (deviceId) => {
    const r = await api.post(`/managed-devices/${deviceId}/temp-access`)
    return r.data
  },
  /** Revoga já. Devolve a concessão (vulnerável se o device não respondeu) ou null. */
  revoke: async (deviceId) => {
    const r = await api.delete(`/managed-devices/${deviceId}/temp-access`)
    return r.status === 204 ? null : r.data
  },
  /** Concessões não revogadas do tenant (sem senha). */
  listOpen: async (tenantId) => {
    const r = await api.get(`/tenants/${tenantId}/temp-accesses`)
    return r.data
  },
}

const STATUS_RANK = { revoked: 0, active: 1, revoking: 2, vulnerable: 3 }

/** Mapa deviceId → concessão mais grave (pode haver mais de uma pendente por device). */
export function indexTempAccessByDevice(list) {
  const map = {}
  for (const a of list || []) {
    const cur = map[a.managedDeviceId]
    if (!cur || (STATUS_RANK[a.status] ?? 0) > (STATUS_RANK[cur.status] ?? 0)) map[a.managedDeviceId] = a
  }
  return map
}

/** Device aceita acesso temporário: host Linux (SSH root) ou router MikroTik (Winbox). */
export function supportsTempAccess(device) {
  if (!device) return false
  if (device.kindCategory === 'Router') return true
  return device.kindCategory === 'Host' && device.kindIsLinux === true
}
